import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/Pages.css';

const PressReleases = () => {
  const [pressReleases, setPressReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('http://localhost:8000/api/press-releases')
      .then(response => {
        setPressReleases(response.data.data || []);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching press releases:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="page">
        <div className="page-hero">
          <h1>Press Releases</h1>
          <p>Loading news...</p>
        </div>
        <div className="page-content">
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-hero">
        <h1>Press Releases</h1>
        <p>Latest news and updates from PITAC</p>
      </div>
      
      <div className="page-content">
        <div className="press-grid">
          {pressReleases.length > 0 ? (
            pressReleases.map(release => (
              <div key={release.id} className="press-card">
                <div className="press-date">{release.published_date}</div>
                <h3>{release.title}</h3>
                <p className="press-summary">{release.summary}</p>
                <button className="read-more-btn">Read More →</button>
              </div>
            ))
          ) : (
            <div className="no-press">No press releases available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PressReleases;